import mainImg from './mainImage.png';
import { BlockPage } from '../../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';

export const PrivilegedUsersBlockPage = () => {
    const topics = [
        <span>Discover and classify your privileged accounts automatically</span>,
        <span>
            Detect and block <span className="font-medium">cross tier access</span>
        </span>,
        <span>Uncover ownership to enable lifecycle management</span>,
        <span>
            Grant access <span className="font-medium">Just in Time</span> to reduce standing privileges
        </span>
    ];

    return (
        <BlockPage
            leftContent={{
                title: 'Privileged Access Security',
                image: mainImg
            }}
            rightContent={{
                icon: Icons.DomainAdmin,
                title: 'Your PAS Journey Starts Here',
                description: (
                    <span>
                        Reduce your attack surface and stay compliant using Silverfort's new Privileged Access Security
                        module.
                    </span>
                ),
                topics: topics,
                accessLink: 'http://www.silverfort.com/pas-signup'
            }}
        />
    );
};
